import React from 'react';
import cx from 'classnames';

export enum PricePanelTheme {
  Gray = 'gray',
  Blue = 'blue',
  Magenta = 'magenta',
}

export interface PricePanelProps {
  billingPrice?: string;
  theme?: PricePanelTheme;
}

export function PricePanel({ billingPrice, theme }: PricePanelProps) {
  return (
    <div className='flex flex-row font-bold v2-text-neutral-900 items-end'>
      <span
        className={cx('text-4xl', {
          'v2-text-neutral-900': theme === undefined,
          'v2-text-neutral-500': theme === PricePanelTheme.Gray,
          'v2-text-blue-500': theme === PricePanelTheme.Blue,
          'v2-text-magenta-500': theme === PricePanelTheme.Magenta,
        })}
      >
        {billingPrice}
      </span>
      <span className='text-[21px]'>/mo</span>
    </div>
  );
}
